<template>
  <div class="flex-grow-1" style="overflow-x: hidden;">
    <main class="main-content site-background w-100">
      <div class="row d-flex align-items-center py-3 mx-0 site-background position-relative">
        <div class="col-auto" style="z-index: 1001; position: relative;">
          <Link :href="moduleUrl" class="text-decoration-none">
            <h1 class="module-name-text ms-lg-4 ms-2 mt-2 mb-0" :style="{ color: moduleColor }">
              {{ moduleName }}
            </h1>
          </Link>
        </div>

        <div class="col d-lg-flex d-none justify-content-center position-absolute start-50 translate-middle-x" style="z-index: 1050;">
          <org-select
            v-if="clients.length > 1"
            :client="client"
            :clients="clients"
            :user="user"
          ></org-select>
        </div>

        <div class="col-auto d-lg-flex d-none ms-auto" style="z-index: 1050; position: relative;">
          <Link v-if="isAvidUser && (isOnDashboardAdmin || isOnHomepage)" href="/toggle-mode" class="me-3 mt-2 small" style="z-index: 1050; position: relative;">
            Switch to {{ user.user_type === 'admin' ? 'Agency' : 'Admin' }} Mode
          </Link>
          
          <button class="btn btn-white me-2" style="z-index: 1050; position: relative;" data-bs-toggle="modal" data-bs-target="#support-modal">
            <img src="/img/icons/avid-icons/help-circle.svg" class="icon" data-bs-toggle="tooltip" title="Help & Support" alt="">
          </button>
          
          <Link href="/logout" method="post" as="button" class="btn btn-white me-2" style="z-index: 1050; position: relative;">
            Log out
          </Link>
        </div>
      </div>

      <div class="d-md-flex d-inline flex-row">
        <side-nav
          :client="client"
          :user="user"
          :current-route="currentRoute"
          :clients="clients"
        ></side-nav>
        
        <div class="position-relative w-100" id="snapshot-content" style="overflow-x: hidden;">
          <status-bar v-if="client && client.is_onboarding"></status-bar>
          <slot />
        </div>
      </div>
    </main>

    <support-modal-dynamic
      :user="user"
      :client="client"
      id="support-modal">
    </support-modal-dynamic>
  </div>
</template>

<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { computed, watch } from 'vue';
import { useClientStore } from '../stores/client';

const page = usePage();
const clientStore = useClientStore();

const user = computed(() => page.props.auth.user);
const clients = computed(() => page.props.clients || []);
const client = computed(() => page.props.client);
const currentRoute = computed(() => page.props.currentRoute || '');

// Module information shared from HandleInertiaRequests
const moduleName = computed(() => page.props.module?.name || 'Dashboard');
const moduleColor = computed(() => page.props.module?.color || '#8192B0');
const moduleUrl = computed(() => page.props.module?.url || '/');

const isAvidUser = computed(() => user.value && user.value.email.includes('@avidai.com'));
const isOnHomepage = computed(() => window.location.pathname === '/');
const isOnDashboardAdmin = computed(() => window.location.pathname === '/dashboard/admin');

// Keep admin nav client list consistent: sync full list to store so OrgSelect can use it on all admin pages
watch(
    () => [page.props.allClients, page.props.auth?.user],
    () => {
        if (user.value?.user_type === 'admin' && Array.isArray(page.props.allClients)) {
            clientStore.setAllClients(page.props.allClients);
        }
    },
    { immediate: true }
);

</script>
